import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ModalComponent } from '../components/modal/modal.component';
import { ModalData } from '../model/modal-data.model';
import { TariffUpdateComponent } from '../modals/tariff-update/tariff-update.component';
import { BaseService } from './base.service';
import { ThemesComponent } from '../modals/themes/themes.component';
import { ThemeService } from './theme.service';
import { FileViewerComponent } from '../components/file-viewer/file-viewer.component';
import { FileModalData, IFileViewerFileWithId } from '../components/file-viewer/file-viewer.interface';
import { WriteMessageComponent } from '../modals/write-message/write-message.component';


@Injectable({
  providedIn: 'root',
})
export class ModalService {
  constructor(
    public dialog: MatDialog,
    public baseService: BaseService,
    public themeService: ThemeService,
  ) {
  }

  openModal<T>(data: ModalData<T>) {

    const modalRef = this.dialog
      .open(ModalComponent, {
        data,
        panelClass: data.containerClass,
        backdropClass: data.backdropClass,
        enterAnimationDuration: data?.enterAnimationDuration || '0ms',
        exitAnimationDuration: data?.exitAnimationDuration || '0ms',
        autoFocus: data?.autoFocus ?? true,
        restoreFocus: data?.restoreFocus ?? false,
        width: this.baseService.isMobile ? '90vw' : data?.width,
        maxWidth: this.baseService.isMobile ? '100vw' : '80vw',
        height: data?.height,
        disableClose: data.disableClose,
        /*
           If you need other special parameters, check the type ModalData and add the needed parameter how,
        like this --> parameter: data?.parameter, or if you need default value for parameter --> parameter: data?.parameter || defaultValue
        */
      });

    return modalRef.afterClosed();
  }

  openTariffUpdate() {
    const dialogData = {
      title: 'errors.max_connected_channels',
      translate: true,
      component: TariffUpdateComponent,
      width: '40vw',
    };
    this.openModal(dialogData);
  }

  openThemes() {
    const dialogData = {
      title: 'choose_topic',
      translate: true,
      component: ThemesComponent,
      width: 'fit-content',
      displayCenter: 'display-center',
    };
    this.openModal(dialogData).subscribe((res) => {
      if (!res) {
        this.themeService.reset();
      }
    });
  }

  openFileViewer(files: IFileViewerFileWithId[], selectedFileIndex: number) {
    const data: FileModalData = { files, currentIndex: selectedFileIndex };

    const modalRef = this.dialog
      .open(FileViewerComponent, {
        data,
        restoreFocus: false,
        panelClass: 'file-overview'
      });

    return modalRef.afterClosed();
  }

  openWriteMessage(){
    const dialogData = {
      title: 'write_message',
      translate: true,
      component: WriteMessageComponent,
      width: '40vw',
      displayCenter: 'display-center',
    };
    this.openModal(dialogData);
  }
}
